import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  LOAD_PACKAGE_LIST,
  LOAD_PACKAGE_LIST_SUCCESS,
  LOAD_PACKAGE_LIST_ERROR,
  LOAD_PACKAGE_DETAIL,
  LOAD_PACKAGE_DETAIL_SUCCESS,
  LOAD_PACKAGE_DETAIL_ERROR,
  UPDATE_PACKAGE,
  UPDATE_PACKAGE_SUCCESS,
  UPDATE_PACKAGE_ERROR,
  CREATE_PACKAGE,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_ERROR,
  DELETE_PACKAGE,
  DELETE_PACKAGE_SUCCESS,
  DELETE_PACKAGE_ERROR,
  RESET_PACKAGE,
  RESET_PACKAGE_LIST,
  RESET_PACKAGE_DETAIL,
} from '../type';

const packageReducer = handleActions(
  new Map([
    [
      LOAD_PACKAGE_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PACKAGE_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: false },
          },
          packageList: {
            data: { $set: action.payload },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_PACKAGE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],

    //Reset package list
    [
      RESET_PACKAGE_LIST,
      (state, action) => {
        return update(state, {
          packageList: {
            data: { $set: [] },
            offset: { $set: 0 },
            limit: { $set: 0 },
            total: { $set: 0 },
          },
        });
      },
    ],
    //Load package detail
    [
      LOAD_PACKAGE_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            packageDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PACKAGE_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            packageDetailLoading: { $set: false },
          },
          packageDetail: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_PACKAGE_DETAIL_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            packageDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      RESET_PACKAGE_DETAIL,
      (state, action) => {
        return update(state, {
          packageDetail: { $set: null },
        });
      },
    ],
    //Create package
    [
      CREATE_PACKAGE,
      state => {
        return update(state, {
          loadingStatus: {
            createPackageLoading: { $set: true },
            assessmentListLoading: { $set: true },
          },
        });
      },
    ],
    [
      CREATE_PACKAGE_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            createPackageLoading: { $set: false },
            assessmentListLoading: { $set: false },
          },
          packageDetail: { $set: action.payload },
        });
      },
    ],
    [
      CREATE_PACKAGE_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            createPackageLoading: { $set: false },
            assessmentListLoading: { $set: false },
          },
        });
      },
    ],

    //Update package
    [
      UPDATE_PACKAGE,
      state => {
        return update(state, {
          loadingStatus: {
            updatePackageLoading: { $set: true },
            assessmentListLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_PACKAGE_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updatePackageLoading: { $set: false },
            assessmentListLoading: { $set: false },
          },
          packageDetail: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_PACKAGE_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            updatePackageLoading: { $set: false },
            assessmentListLoading: { $set: false },
          },
        });
      },
    ],

    [
      DELETE_PACKAGE,
      state => {
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: true },
          },
        });
      },
    ],
    [
      DELETE_PACKAGE_SUCCESS,
      (state, action) => {
        const newPackageList = state.packageList.data.filter(item => {
          return item.id !== action.payload;
        });
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: false },
          },
          packageList: {
            data: {
              $set: newPackageList,
            },
          },
        });
      },
    ],
    [
      DELETE_PACKAGE_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            packageListLoading: { $set: false },
          },
        });
      },
    ],
    [
      RESET_PACKAGE,
      state => {
        return update(state, {
          loadingStatus: {
            packageDetailLoading: { $set: false },
          },
          packageDetail: { $set: null },
        });
      },
    ],
  ]),
  initialState,
);
export default packageReducer;
